export const parseISOLocal = (s) =>
  new Date(
    Date.UTC(...s.split(/\D/).map((p, i) => (i === 1 ? p - 1 : p)), 12)
  ).valueOf();
